var React = require("react");

var style = {
	icon: {
		transformOrigin: '50% 50% 4px'
	}
};

module.exports = React.createClass({
	displayName: "Loading",

	propTypes: {
		loading: React.PropTypes.bool.isRequired,
		style: React.PropTypes.object,
		iconStyle: React.PropTypes.object
	},

	getDefaultProps: function() {
		return {
			loading: false
		};
	},

	render: function() {
		var me = this, calculatedStyle = Object.assign({}, style.icon, me.props.style);
		
		return (
			<div className={"loading " + (me.props.loading ? '' : "loaded")}>
				<span className="icon-loading" style={calculatedStyle}></span>
			</div>
		);
	}
});


// WEBPACK FOOTER //
// ./src/components/Loading.jsx